import { createIcon } from '~/utils';

export const FacebookIcon = createIcon({
  viewBox: '0 0 16 16',
  path: (
    <path d='M16 8.04868C16 3.60243 12.4194 0 8 0C3.58065 0 0 3.60243 0 8.04868C0 12.0665 2.92581 15.3963 6.74839 16V10.3757H4.71613V8.04868H6.74839V6.27667C6.74839 4.25801 7.94194 3.14483 9.77097 3.14483C10.6452 3.14483 11.5613 3.30061 11.5613 3.30061V5.28032H10.5516C9.55806 5.28032 9.24839 5.9002 9.24839 6.53631V8.04868H11.4677L11.1129 10.3757H9.24839V16C13.0742 15.3963 16 12.0665 16 8.04868Z' />
  ),
});
